import { endOfWeek, startOfWeek } from 'date-fns'
import locales from 'utils/dateFns/locales'

export const startOfWeekLocale = (date) => startOfWeek(date, {
  locale: locales[global.__localeId__]
})

export const endOfWeekLocale = (date) => endOfWeek(date, {
  locale: locales[global.__localeId__]
})
